var exports = {
  "Nr": "ServerTagGuildProfileCard.module__card___QmliZ2",
  "vK": "ServerTagGuildProfileCard.module__banner___QmliZ2",
  "_e": "ServerTagGuildProfileCard.module__bannerImage___QmliZ2",
  "sM": "ServerTagGuildProfileCard.module__bannerTint___QmliZ2",
  "rf": "ServerTagGuildProfileCard.module__body___QmliZ2",
  "HT": "ServerTagGuildProfileCard.module__iconRow___QmliZ2",
  "Vm": "ServerTagGuildProfileCard.module__iconFrame___QmliZ2",
  "Dp": "ServerTagGuildProfileCard.module__iconImage___QmliZ2",
  "Pz": "ServerTagGuildProfileCard.module__iconPlaceholder___QmliZ2",
  "S7": "ServerTagGuildProfileCard.module__nameRow___QmliZ2",
  "UU": "ServerTagGuildProfileCard.module__name___QmliZ2",
  "M1": "ServerTagGuildProfileCard.module__stats___QmliZ2",
  "dJ": "ServerTagGuildProfileCard.module__stat___QmliZ2",
  "gW": "ServerTagGuildProfileCard.module__statDot___QmliZ2",
  "rR": "ServerTagGuildProfileCard.module__statDotOnline___QmliZ2",
  "rb": "ServerTagGuildProfileCard.module__statDotMembers___QmliZ2",
  "zu": "ServerTagGuildProfileCard.module__created___QmliZ2",
  "Jm": "ServerTagGuildProfileCard.module__tagRow___QmliZ2",
  "uU": "ServerTagGuildProfileCard.module__tagPill___QmliZ2",
  "D4": "ServerTagGuildProfileCard.module__tagPillText___QmliZ2",
  "o1": "ServerTagGuildProfileCard.module__actions___QmliZ2",
  "dr": "ServerTagGuildProfileCard.module__goButton___QmliZ2",
};

module.exports = exports;
